import { useState } from "react";
import {
  AnimatingHead,
  ScrollableGallery,
  UpgradeModal,
} from "../../Components";
import { downloadImage } from "../../services";

const pics = [
  {
    title: "Heavenly",
  },
  {
    title: "Fantasy",
  },
  {
    title: "Gouache",
  },
  {
    title: "Surreal",
  },
  {
    title: "Synthwave",
  },
  {
    title: "Fantasy",
  },
  {
    title: "Gouache",
  },
  {
    title: "Surreal",
  },
];

function Authenticated() {
  /*
   *Pic is Generating or not
   */
  const [genrating, setGenerating] = useState(false);
  /*
   *To show/hide update modal
   */
  const [showModal, setShowModal] = useState(true);
  /*
   *To store selected image
   */
  const [selectedImage, setSelectedImage] = useState();
  /*
   *To Checke image is selected or not
   */
  const [isSelected, setIsSelected] = useState(false);
  /*
   *Select Image
   */
  const onChangeHandler = (e) => {
    /*
     *Create temporary Url of selected image fore preview
     */
    setSelectedImage(URL.createObjectURL(e.target.files[0]));
    setIsSelected(true);
  };

  return (
    <div className="container relative mx-auto mt-14">
      {/* <div className="hidden lg:block bg-gradient-to-b from-cyan to-blue p-2 rounded w-[110px]">
        <img
          className="h-24 border-b-4 border-white w-full"
          src="/image.svg"
          alt="img"
        />
        <div className="h-24 border-b-4 border-white"></div>
        <div className="h-24 border-b-4 border-white"></div>
        <div className="h-24 border-b-4 border-white"></div>
      </div> */}
      <div className="pl-6m mr-6 md:mr-0 w-full">
        <div
          className={`flex flex-col md:flex-row items-center md:items-end my-6 ${
            isSelected && "md:items-center"
          }`}
        >
          <div>
            <h1 className="font-semibold mb-1.5 text-2xl text-center md:text-left">
              Image Generator
            </h1>
            <p className="font-light text-base mb-8 text-center md:text-left	">
              Do Androids Dream of Electric Sheep?
            </p>
            <div className="flex flex-col items-center md:items-start md:flex-row">
              <div>
                <h2 className="text-center md:text-left font-semibold mb-2.5">
                  Your text prompt
                </h2>
                <input
                  className="border h-[53px] w-full rounded	 border-gray p-2 sm:w-[468px]	"
                  type="text"
                  placeholder="E.g. Post apocalyptic wonderland"
                />
              </div>

              <h1 className="font-semibold my-4 md:my-0 md:mbb-[58px] md:mx-6 ">
                OR
              </h1>
            </div>
          </div>
          {/* <div className="flexx  flex-col items-center md:items-start	 md:flex-row text-lg my-6"> */}

          <div className="flex items-center md:items-start  flex-col">
            <h2 className="font-semibold mb-2.5">Start from an image</h2>
            <div
              className={`border shadow	 ml-4 mb-1 md:ml-0 border-gray rounded  p-2 	cursor-pointer  ${
                isSelected && "p-3.5 h-52 max-w-80"
              }`}
            >
              <input
                id="file-upload"
                onChange={onChangeHandler}
                className="hidden"
                type="file"
              />
              <label htmlFor="file-upload">
                {isSelected ? (
                  /*
                   *Selected Image
                   */
                  <img
                    className="m-0 w-full h-full"
                    src={selectedImage}
                    alt={selectedImage}
                  />
                ) : (
                  /*
                   *attach icon
                   */
                  <img
                    htmlFor="file-upload"
                    className="m-0 w-full h-full cursor-pointer"
                    src={isSelected ? "/mountain.png" : "/upload.svg"}
                    alt="upload"
                  />
                )}
              </label>
            </div>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-semibold text-lg">Chose a Style</h3>
            <p className="text-blue underline cursor-pointer mr-[18px] md:mr-0">
              See All
            </p>
          </div>
          <div className="flex overflow-x-auto horizontal-scroll last:mr-0">
            {/*
             *Horizontal Scrollable
             */}
            <ScrollableGallery pics={pics} />
          </div>
        </div>
        <div className="flex justify-center md:justify-start items-center mt-7">
          <button
            disabled={genrating}
            className={`rounded font-semibold border-2 border-blue text-white px-10 py-3.5 bg-blue ${
              !genrating && "hover:bg-white hover:text-blue"
            }  ${genrating && "opacity-50	"}`}
            onClick={() => {
              setGenerating(!genrating);
            }}
          >
            {genrating
              ? /*
                 *On generating
                 */
                "Generating..."
              : /*
                 *On generating done or Before Generating
                 */
                "Generate"}
          </button>
          {genrating ? (
            <div className="ml-4">
              <AnimatingHead />
            </div>
          ) : (
            <img className="ml-4" src="/head.svg" alt="head" />
          )}
        </div>
      </div>
      {/*
       *Genrated Image
       */}
      <div className="rounded my-11 border border-gray shadow max-w-[628px] px-9 pt-9">
        <img className="w-full h-full" src="/mountain.png" alt="img" />
        <div className="mt-3 mb-[26px] flex items-center justify-between">
          <p className="font-semibold text-lg flex items-center	">
            Mountain
            <span className="flex font-light text-sm ml-1.5">
              <img src="/dot.svg" className="mr-1.5" alt="dot" />
              created a minute ago
            </span>
          </p>
          <div className="flex items-center">
            <img
              onClick={() => downloadImage("/mountain.png")}
              className="cursor-pointer"
              src="/download.svg"
              alt="download"
            />
            <img className="ml-8 cursor-pointer" src="/send.svg" alt="send" />
          </div>
        </div>
      </div>
      {showModal && (
        <div className="h-full fixed top-28 flex items-start justify-center w-full right-0 left-0 ">
          <UpgradeModal setShowModal={setShowModal} />
        </div>
      )}
    </div>
  );
}

export default Authenticated;
